import { get } from '../../../../utils/get';
export var getPrice = function (item) {
    if (item === void 0) { item = {}; }
    var price = get(item, 'program.settings.pricing.singlePayment.price.amount');
    if (price === '') {
        return undefined;
    }
    return price;
};
